// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3plUM","addWidgetButton":"Header_addWidgetButton__KdDH8","dashboardTabs":"Header_dashboardTabs__3Ic54","active":"Header_active__206I9"};